import { IndividuState, INDIVIDUS_STORE as s } from './type';
import { MutationTree } from 'vuex';
import { Individu } from '@/models/Individu';
import { Autorisations } from '@/models/Autorisations';
import { HistoScolarite } from '@/models/HistoScolarite';
import { NiveauScolaireDocument } from '@/models/NiveauScolaireDocument';
import { Ville } from '@/models/Ville';
import { EtablissementScolaireDocument } from '@/models/EtablissementScolaireDocument';
import { ClasseScolaireDocument } from '@/models/ClasseScolaireDocument';
import { EnseignantScolaireDocument } from '@/models/EnseignantScolaireDocument';
import { AnneeScolaireDocument } from '@/models/AnneeScolaireDocument';
import { EtablissementScolaireNiveauDocument } from '@/models/EtablissementScolaireNiveauDocument';
import { ClasseScolaireNiveauDocument } from '@/models/ClasseScolaireNiveauDocument';
import { ClasseScolaireEnseignantDocument } from '@/models/ClasseScolaireEnseignantDocument';

export const mutations: MutationTree<IndividuState> = {
    [s.SET_LIST_INDIVIDUS](state, newval: Array<Individu>) {
        state.listIndividus = [];
        state.listIndividus = newval;
    },
    [s.SET_FILTRED_LIST_INDIVIDUS](state, newval: Array<Individu>) {
        state.filtredListe = [];
        state.filtredListe = newval;
    },
    [s.SET_INDIVIDU](state, newval: Individu) {
        state.individu = newval;
    },
    [s.SET_LIST_ECOLES](state, newval: Array<EtablissementScolaireDocument>) {
        state.listEcoles = newval;
    },
    [s.SET_LIST_CLASSES](state, newval: Array<ClasseScolaireDocument>) {
        state.listClasses = newval;
    },
    [s.SET_LIST_INSTITS](state, newval: Array<EnseignantScolaireDocument>) {
        state.listInstits = newval;
    },
    [s.SET_LIST_HISTO](state, newval: Array<HistoScolarite>) {
        state.listHisto = newval;
    },
    [s.SET_LIST_AUTORISATIONS](state, newval: Array<Autorisations>) {
        state.listAutorisations = newval;
    },
    [s.SET_LIST_NIVEAU](state, newval: Array<NiveauScolaireDocument>) {
        state.listNiveau = newval;
    },
    [s.SET_LIST_VILLE](state, newval: Array<Ville>) {
        state.listVille = newval;
    },
    [s.SET_CURRENT_ANNEE_SCOLAIRE](state, newval: AnneeScolaireDocument) {
        state.currentAnneeScolaire = newval;
    },
    [s.SET_ETABLISSEMENT_SCOLAIRE_NIVEAU](state, newval: Array<EtablissementScolaireNiveauDocument>) {
        state.listEtablissementScolaireNiveau = newval;
    },
    [s.SET_CLASSE_SCOLAIRE_NIVEAU](state, newval: Array<ClasseScolaireNiveauDocument>) {
        state.listClasseScolaireNiveau = newval;
    },
    [s.SET_CLASSE_SCOLAIRE_ENSEIGNANT](state, newval: Array<ClasseScolaireEnseignantDocument>) {
        state.listClasseScolaireEnseignant = newval;
    },
    [s.SET_INDIVIDU_DU_JOUR](state, newval: boolean) {
        state.filtreIndividusJour = newval;
    },
    [s.SET_FILTRE_ACTIFS](state, newval) {
        switch (newval.filtre) {
            case "prenom": {
                state.filtrePrenom = newval.value
                break;
            }
            case "age": {
                state.filtreAge.actif = true;
                state.filtreAge.value = newval.value
                break;
            }
            case "classes": {
                state.filtreClasses.actif = true;
                state.filtreClasses.value = []
                state.filtreClasses.value = newval.value
                break;
            }
            case "ecoles": {
                state.filtreEcoles.actif = true;
                state.filtreEcoles.value = []
                state.filtreEcoles.value = newval.value
                break;
            }
            case "instit": {
                state.filtreInstit.actif = true;
                state.filtreInstit.value = []
                state.filtreInstit.value = newval.value
                break;
            }
            case "niveau": {
                state.filtreNiveau.actif = true;
                state.filtreNiveau.value = []
                state.filtreNiveau.value = newval.value
                break;
            }
            case "ville": {
                state.filtreVille.actif = true;
                state.filtreVille.value = newval.value
                break;
            }
            case "pointage": {
                state.filtrePointage.actif = true;
                state.filtrePointage.value = newval.value
                break;
            }
            case "groupes": {
                state.filtreGroupes.actif = true;
                state.filtreGroupes.value = []
                state.filtreGroupes.value = newval.value
                break;
            }
            case "regim": {
                state.filtreRegim.actif = true;
                state.filtreRegim.value = []
                state.filtreRegim.value = newval.value
                break;
            }
            default:
                break;
        }
    },
    [s.SET_FILTRE_CLOSE](state, newval) {
        switch (newval) {
            case "prenom": {
                state.filtrePrenom = false
                break;
            }
            case "age": {
                state.filtreAge.actif = false;
                state.filtreAge.value = {
                    ageMin: 0,
                    ageMax: 99
                }
                break;
            }
            case "classes": {
                state.filtreClasses.actif = false;
                state.filtreClasses.value = []
                break;
            }
            case "niveau": {
                state.filtreNiveau.actif = false;
                state.filtreNiveau.value = []
                break;
            }
            case "ecoles": {
                state.filtreEcoles.actif = false;
                state.filtreEcoles.value = []
                break;
            }
            case "instit": {
                state.filtreInstit.actif = false;
                state.filtreInstit.value = []
                break;
            }
            case "ville": {
                state.filtreVille.actif = false;
                state.filtreVille.value = ''
                break;
            }
            case "pointage": {
                state.filtrePointage.actif = false;
                state.filtrePointage.value = ''
                break;
            }
            case "groupes": {
                state.filtreGroupes.actif = false;
                state.filtreGroupes.value = []
                break;
            }
            case "regim": {
                state.filtreRegim.actif = false;
                state.filtreRegim.value = []
                break;
            }
            case "all": {
                state.filtredListe = Array.from(state.listIndividus);
                state.filtrePrenom = false
                state.filtreAge.actif = false;
                state.filtreAge.value = {
                    ageMin: 0,
                    ageMax: 99
                };
                state.filtreClasses.actif = false;
                state.filtreClasses.value = []
                state.filtreNiveau.actif = false;
                state.filtreNiveau.value = []
                state.filtreInstit.actif = false;
                state.filtreInstit.value = [];
                state.filtreVille.actif = false;
                state.filtreVille.value = '';
                state.filtreEcoles.actif = false;
                state.filtreEcoles.value = []
                state.filtrePointage.actif = false;
                state.filtrePointage.value = ''
                state.filtreGroupes.actif = false;
                state.filtreGroupes.value = [];
                state.filtreRegim.actif = false;
                state.filtreRegim.value = [];
                break;
            }
            default: {
                state.filtrePrenom = false
                state.filtreAge.actif = false;
                state.filtreAge.value = {
                    ageMin: 0,
                    ageMax: 99
                };
                state.filtreClasses.actif = false;
                state.filtreClasses.value = []
                state.filtreNiveau.actif = false;
                state.filtreNiveau.value = []
                state.filtreInstit.actif = false;
                state.filtreInstit.value = [];
                state.filtreVille.actif = false;
                state.filtreVille.value = '';
                state.filtrePointage.actif = false;
                state.filtrePointage.value = ''
                state.filtreGroupes.actif = false;
                state.filtreGroupes.value = [];
                state.filtreRegim.actif = false;
                state.filtreRegim.value = [];
                break;
            }
        }
    },
}